import { createSlice } from "@reduxjs/toolkit"

export const authSlice = createSlice({
  name: "user",
  initialState: {
    url: "",
    auth: {},
    zones: [],
    bins: [],
    binList: [],
    markers: [],
    vehicleLocation: null,
  },
  reducers: {
    addUserAuth: (state, { payload }) => {
      state.auth = payload
    },
    addZones: (state, { payload }) => {
      state.zones = payload
    },
    modifyZone: (state, { payload }) => {
      state.url = payload
    },
    getBins: (state, { payload }) => {
      state.bins = payload
    },
    addBins: (state, { payload }) => {
      state.binList = payload
    },
    modifyBin: (state, { payload }) => {
      const index = state.binList.findIndex(bin => bin.id === payload.id);
      if (index !== -1) {
        state.binList[index] = payload;
      }
    },
    getMarkers: (state, { payload }) => {
      state.markers = payload
    },
    updateVehicleLocation: (state, { payload }) => {
      state.vehicleLocation = payload;
    },
  }
})
export const {
  addUserAuth,
  addZones,
  modifyZone,
  getBins,
  addBins,
  modifyBin,
  getMarkers,
  updateVehicleLocation,
} = authSlice.actions
export default authSlice.reducer
